// extracted by mini-css-extract-plugin
export default {"hidden":"SectionProduction_hidden__JiET2","placeHolderShimmer":"SectionProduction_placeHolderShimmer__sDcFh"};